import PreviewBanner from './PreviewBanner';

const PreviewBannerWrapper = (props) => {
  const {values} = props;

  return (
    <div className="banner-background singlePreview">
      <PreviewBanner values={values} />
    </div>
  )
}

export default PreviewBannerWrapper